// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/clickOutside.js#1 $
'use strict';
angular.module('tcApp')
.directive('tcClickOutside', function($document, tcConstants) {
		return {
			restrict: 'A',
			scope: {
				clickOutsideActive: '=',
				clickOutsideFunction: '&',
			},
			link: function(scope, element) {
				var isTouchGesture = false;
				
				var clickHandler = function($event) {
					// Ignore the click if this directive is currently inactive
					if (!scope.clickOutsideActive) return;
					if (isTouchGesture) return;
					isTouchGesture = false;
					
					// Make sure we have an event with a target
					if (angular.isUndefined($event) || !$event.target) return;
					
					// Return early if the click was inside the element
					for (var currentElement = $event.target; currentElement; currentElement = currentElement.parentNode) {
						if (currentElement === element[0]) return;
					}
					// Otherwise call the clickOutside function
					return scope.$apply(function() {
						$event.stopPropagation();
						return scope.clickOutsideFunction(scope);
					});
				};
				
				var touchMoveHandler = function() {
					isTouchGesture = true;
				};

				var touchEndHandler = function() {
					isTouchGesture = false;
				};
				
				// Bind our click event, and remove when our directive scope is destroyed
				$document.on(tcConstants.CROSS_DEVICE_EVENT.CLICK, clickHandler);
				
				var touchEnabled = (tcConstants.CROSS_DEVICE_EVENT.CLICK !== 'click');
				// Need to add redundant click listener for touch screen devices, as some support mouse (e.g. touch screen laptop)
				if (touchEnabled) {
					$document.on('click', clickHandler);
					$document.on('touchmove', touchMoveHandler);
					$document.on('touchend', touchEndHandler);
				}
				scope.$on('$destroy', function() {
					$document.off(tcConstants.CROSS_DEVICE_EVENT.CLICK, clickHandler);
					if (touchEnabled) {
						$document.off('click', clickHandler);
						$document.off('touchmove', touchMoveHandler);
						$document.off('touchend', touchEndHandler);
					}
				});
			}
		};
	}
);
